<template>
  <v-dialog v-model="open" @input="v => v || closeDialog()" max-width="500px">
    <v-card>
      <v-card-title>{{ "forgot_password_title" | translate }}</v-card-title>
      <p class="forgot_password-text">
        {{ "forgot_password_info" | translate }}
      </p>
      <v-card-text class="pb-0">
        <v-layout row wrap align-center justify-center>
          <v-flex xs4 md4 align-content-center>
            <v-text-field
              pt1
              :label="'lng_login_username' | translate"
              :value="currentUserName"
              v-model="currentUserName"
              v-on:keyup.enter="sendForgotPasswordRequest"
            />
          </v-flex>
        </v-layout>
        <div class="captchaContainer">
          <vue-recaptcha
            :sitekey="reCaptchaSiteKey"
            @verify="onVerified($event)"
          >
          </vue-recaptcha>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="dialog(false)">{{
              "lng_close" | translate
            }}</v-btn>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              :class="[
                reCaptchaVerified && currentUserName.length
                  ? 'primary-btn'
                  : 'disabled-btn'
              ]"
              block
              flex
              xs12
              flat
              :disabled="
                reCaptchaVerified && currentUserName.length ? false : true
              "
              @click="sendForgotPasswordRequest()"
              >{{ "lng_submit" | translate }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service.js";
import { translate } from "../common/HelperFunctions.js";
import VueRecaptcha from "vue-recaptcha";
import { reCaptchaSiteKey } from "../common/Constant.js";

export default {
  name: "ResetPasswordDialog",
  components: { VueRecaptcha },
  data() {
    return {
      open: false,
      currentUserName: "",
      reCaptchaVerified: false,
      reCaptchaSiteKey,
    };
  },
  props: {
    userName: {
      type: String,
      default: undefined
    },
    dialog: {
      type: Function,
      default: undefined
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    selectedLanguage: {
      type: String,
      default: ""
    },
    onResponse: {
      type: Function,
      default: undefined
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  mounted() {
    this.currentUserName = this.userName;
  },
  watch: {
    openDialog: function(newVal) {
      this.open = newVal;
    },
    userName: function(newVal) {
      this.currentUserName = newVal;
    }
  },
  methods: {
    onVerified() {
      this.reCaptchaVerified = true;
    },
    translate(text) {
      if (window.selectedLang[text]) {
        return window.selectedLang[text];
      } else if (window.ukLang[text]) {
        return window.ukLang[text];
      } else {
        return text;
      }
    },
    closeDialog() {
      // A prop function to open or close modal
      this.dialog(false);
    },
    // checkTextFieldValue(val) {
    //   this.sliderValues.val = val;
    //   this.inputValue = val;
    //   if (
    //     this.sliderValues.val > this.sliderValues.max ||
    //     this.sliderValues.val < this.sliderValues.min
    //   ) {
    //     this.wrongValue = true;
    //   } else {
    //     this.wrongValue = false;
    //     this.rangeValue = val;
    //   }
    // },
    // function for update field data
    async sendForgotPasswordRequest() {
      let response;
      try {
        response = await GlobalService.forgotPassRequest(
          this.selectedLanguage,
          this.currentUserName
        );
        this.dialog(false);
        this.onResponse(response);
      } catch (e) {
        var resObj = { status: 1, message: "Request Failed! Try again later" };
        // A prop function to open or close modal
        this.dialog(false);
        // A prop function to show alert dialog
        this.onResponse(resObj);
      }
    }
  }
};
</script>
<style>
.v-card__title {
  background-color: rgb(84, 110, 122);
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
  letter-spacing: 0.005em;
  font-weight: 400;
  width: 100%;
  height: 64px;
  max-height: 64px;
  padding: 0 16px;
  margin: 0;
}
.v-input__slot {
  margin-bottom: 0;
}
.v-dialog {
  border-radius: 4px;
  overflow: hidden;
}
.raised-btn {
  background-color: rgb(250, 250, 250);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.primary-btn {
  background-color: rgb(84, 110, 122);
  color: #fff !important;
}
.disabled-btn {
  background-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}
.theme--light.v-btn svg {
  fill: #455a64;
}
.error-text {
  font-size: 14px;
  padding: 0;
  margin: 0;
  color: red;
  text-align: center;
}
.forgot_password-text {
  font-size: 14px;
  text-align: center;
  padding: 0;
  margin: 8px 0;
}
.captchaContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
}
</style>
